import usePageMetadata from '@hooks/usePageMetadata'
import Head from 'next/head'
import { FunctionComponent } from 'react'
import { generateInitialSchema } from '@utils/schema'

const SchemaInjector: FunctionComponent = () => {
  const pageMetadata = usePageMetadata()

  return (
    <Head>
      {Object.entries(generateInitialSchema(pageMetadata))
        .filter(([_, schemaValue]) => !!schemaValue)
        .map(([key, value]) => (
          <script
            key={key}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(value) }}
          />
        ))}
    </Head>
  )
}

export default SchemaInjector
